import useUserStore from '@core/stores/useUserStore';
import { getCookie } from 'tiny-cookie';
import tenantConfig, { TENANT_COOKIE_STORAGE_KEY } from '../../tenantConfig';

/**
 * Function to retrieve the current tenant key.
 *
 * This function combines tenant information from a cookie and a provided tenant configuration
 * to provide the UI key and tenant key for the current session.
 *
 * @returns An object containing:
 *  - uiKey: The UI key derived from the tenant key.
 *  - uiApiTenantKey: The API tenant key derived from the tenant key.
 *  - tenantKey: The tenant key retrieved from the cookie or the tenant configuration.
 */

export const getTenantInfo = () => {
    const userStore = useUserStore.getState(); // Access tenant configuration from the store
    const tenantConfigFromStore = userStore.tenantConfig; // Access tenant configuration from the store
    const cookieTenantKey = getCookie(TENANT_COOKIE_STORAGE_KEY);

    const tenantKeyFromCookie = getCookie(TENANT_COOKIE_STORAGE_KEY)?.split('_')[1];

    const derivedTenantKey = tenantKeyFromCookie || tenantConfigFromStore?.tenantKey;

    const tenantConfigFromTenantKey =
        tenantConfig?.find((config) => config.ui + '_' + config.tenantKey === cookieTenantKey) ||
        tenantConfig?.find((config) => config.tenantKey === derivedTenantKey);

    return {
        uiKey: tenantConfigFromTenantKey?.ui || tenantConfigFromTenantKey?.tenantKey || '',
        uiApiTenantKey: tenantConfigFromTenantKey?.tenantKey,
        tenantKey: derivedTenantKey,
    };
};
